export const host = "https://or-mern-chatapp-backend.onrender.com"

export const registerRoute = `${host}/register`;
export const loginRoute = `${host}/login`;
export const setavatarRoute = `${host}/setavatar`;
export const allUSersRoute = `${host}/allusers`;
export const sendMessageRoute = `${host}/addmessage`;
export const getAllMessagesRoute = `${host}/getmessage`;
